/**
 * @description: 存取酒汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="war-cqh-report">
        <div class="cqjh-list">
            <el-form :inline="true" size="small" :model="cqjh_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="cqjh_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="cqjh_list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="cqjh_list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="cqjh_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="cqjhShopChange">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="区域">
                    <el-select v-model="cqjh_list_form.room_area_name" filterable clearable placeholder="请选择区域" :disabled="cqjh_list_form.room_area_disabled" @change="cqjhRoomArea">
                        <el-option v-for="item in room_area_list" :key="item.id" :label="item.name" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库" v-show="cqjh_sortby == 'take_deposit_store'">
                    <el-select v-model="cqjh_list_form.store_id" filterable clearable placeholder="请选择仓库" :disabled="cqjh_list_form.store_disabled">
                        <el-option v-for="item in store_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select v-model="cqjh_list_form.goods_type" filterable clearable placeholder="请选择商品类型">
                        <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="cqjh_list_form.goods_name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="cqjh_list_form.mobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="cqjhQuery">查询</el-button>
                    <el-button @click="cqjhExportSet">导出</el-button>
                    <el-button class="cqjh-type el-button--primary" @click="cqjhSortBy('take_deposit_goods')">按商品统计</el-button>
                    <el-button class="cqjh-type" @click="cqjhSortBy('take_deposit_store')">按出货仓库统计</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="cqjh_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column width="130" label="门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column width="130" label="商品名称">
                    <template slot-scope="scope">
                        {{scope.row.goods_name.length > '14' ? scope.row.goods_name.slice(0, 14) + '...' : scope.row.goods_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="in_quantity" label="寄存总量"></el-table-column>
                <el-table-column prop="out_quantity" label="取酒总量"></el-table-column>
                <el-table-column prop="in_price_total" label="寄存金额" v-if="cqjh_sortby == 'take_deposit_goods'"></el-table-column>
                <el-table-column prop="out_price_total" label="取酒金额" v-if="cqjh_sortby == 'take_deposit_goods'"></el-table-column>
                <el-table-column prop="store_name" label="仓库" v-if="cqjh_sortby == 'take_deposit_store'"></el-table-column>
                <el-table-column prop="buying_price" label="进货单价"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-4">寄存总量:</label>
                    <div class="list-total">{{cqjh_total_in_quantity}}</div>
                    <label class="list-label-4">取酒总量:</label>
                    <div class="list-total">{{cqjh_total_out_quantity}}</div>
                    <label class="list-label-6" v-if="cqjh_sortby == 'take_deposit_goods'">寄存金额合计:</label>
                    <div class="list-total" v-if="cqjh_sortby == 'take_deposit_goods'">{{cqjh_in_price_total}}</div>
                    <label class="list-label-6" v-if="cqjh_sortby == 'take_deposit_goods'">取酒金额合计:</label>
                    <div class="list-total" v-if="cqjh_sortby == 'take_deposit_goods'">{{cqjh_out_price_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="cqjh_list_page"
                    :total="cqjh_list_total"
                    @current-change="getCqjhList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="cqjh_list_export">
                <div v-show="cqjh_sortby == 'take_deposit_goods'">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <el-checkbox :indeterminate="cqjh_export_sign" v-model="cqjh_export_all" @change="cqjhExportAll">全选</el-checkbox>
                    <el-checkbox-group v-model="cqjh_export_ids" @change="cqjhExportChange">
                        <el-checkbox label="shop_name">门店</el-checkbox>
                        <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                        <el-checkbox label="goods_name">商品名称</el-checkbox>
                        <el-checkbox label="goods_unit_name">单位</el-checkbox>
                        <el-checkbox label="in_quantity">寄存总量</el-checkbox>
                        <el-checkbox label="out_quantity">取酒总量</el-checkbox>
                        <el-checkbox label="in_price_total">寄存金额</el-checkbox>
                        <el-checkbox label="out_price_total">取酒金额</el-checkbox>
                        <el-checkbox label="buying_price">进货单价</el-checkbox>
                    </el-checkbox-group>
                    <h3>请选择导出报表的文件格式</h3>
                    <el-radio v-model="cqjh_export_type" label="1">excel表格</el-radio>
                    <el-radio v-model="cqjh_export_type" label="2">pdf文件</el-radio>
                </div>
                <div v-show="cqjh_sortby == 'take_deposit_store'">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <el-checkbox :indeterminate="cqjh_export_sign" v-model="cqjh_export_all" @change="cqjhExportAll">全选</el-checkbox>
                    <el-checkbox-group v-model="cqjh_export_ids" @change="cqjhExportChange">
                        <el-checkbox label="shop_name">门店</el-checkbox>
                        <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                        <el-checkbox label="goods_name">商品名称</el-checkbox>
                        <el-checkbox label="goods_unit_name">单位</el-checkbox>
                        <el-checkbox label="in_quantity">寄存总量</el-checkbox>
                        <el-checkbox label="out_quantity">取酒总量</el-checkbox>
                        <el-checkbox label="store_name">仓库</el-checkbox>
                        <el-checkbox label="buying_price">进货单价</el-checkbox>
                    </el-checkbox-group>
                    <h3>请选择导出报表的文件格式</h3>
                    <el-radio v-model="cqjh_export_type" label="1">excel表格</el-radio>
                    <el-radio v-model="cqjh_export_type" label="2">pdf文件</el-radio>
                </div>
            </div>
            <!-- 预约导出弹窗 --><!-- 预约导出弹窗 -->
            <div class="book-export-pop ele-hide" ref="book_export_pop">
                <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
                <div class="pop-row center">
                    <el-button type="primary" @click="doBookExport">预约导出</el-button>
                    <el-button @click="cancelExport">取消</el-button>
                </div>
                <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
                <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                    <div class="time">{{book_export_log_list[0].create_time}}</div>
                    <div class="right">
                        <span class="status">{{book_export_log_list[0].status_name}}</span>
                        <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                store_list: [],
                goods_type_list: [],
                cqjh_list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    room_area: '',
                    room_area_name: '',
                    room_area_disabled: false,
                    store_id: '',
                    store_disabled: false,
                    goods_type: '',
                    goods_name: '',
                    mobile: '',
				},
				cqjh_list: [],
				cqjh_list_page: 1,
                cqjh_list_total: 0,
                cqjh_export_sign: false,
				cqjh_export_all: false,
                cqjh_export_ids: [],
                cqjh_export_list1: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'in_quantity', 'out_quantity', 'in_price_total', 'out_price_total', 'buying_price'],
                cqjh_export_list2: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'in_quantity', 'out_quantity', 'store_name', 'buying_price'],
                cqjh_export_type: '1',
                cqjh_sortby: 'take_deposit_goods',
                cqjh_total_in_quantity: '',
                cqjh_total_out_quantity: '',
                cqjh_in_price_total: '',
                cqjh_out_price_total: '',
                book_export_log_list: [],
            }
        },
        mounted: function() {
            // 日期
            this.cqjh_list_form.start_date = moment().format('YYYY-MM-DD 08:00');
            this.cqjh_list_form.end_date = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.cqjh_list_form.shop_id = this.shop_list[0].id;
                this.getRoomArea(this.shop_list[0].id);
                this.getGoodsType();
                this.cqjhSortBy('take_deposit_goods');
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.cqjh_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.cqjh_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.cqjh_list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.cqjh_list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.cqjh_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.cqjh_list_form.start_date = start.format('YYYY-MM-DD 08:00');
                    _this.cqjh_list_form.end_date = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.cqjh_list_form.room_area = '';
                    _this.cqjh_list_form.room_area_name = '';
                    _this.cqjh_list_form.room_area_disabled = true;
                } else {
                    _this.cqjh_list_form.room_area = '';
                    _this.cqjh_list_form.room_area_name = '';
                    _this.cqjh_list_form.room_area_disabled = false;
                    _this.setShopDefaultTime(shop_id);
                    Vue.axios.post('Shop/getRoomArea', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.room_area_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },
            // 仓库数据
            getStore: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.cqjh_list_form.store_id = '';
                    _this.cqjh_list_form.store_disabled = true;
                } else {
                    _this.cqjh_list_form.store_id = '';
                    _this.cqjh_list_form.store_disabled = false;
                    Vue.axios.post('PublicData/api_getStoreList', {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.store_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },
            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            cqjhShopChange(val) {
                this.getRoomArea(val);
                this.getStore(val);
            },
            cqjhRoomArea(val) {
				this.cqjh_list_form.room_area = val.id;
				this.cqjh_list_form.room_area_name = val.name;
			},
            getCqjhList(page) {
				const _this = this;

                _this.loading = true;
                _this.cqjh_list_page = page;
                let url = "FinanceReport/getTakeDepositSumListByGoods";
                let data = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.cqjh_list_form.start_date,
                            "end_date": _this.cqjh_list_form.end_date,
                            "shop_id": _this.cqjh_list_form.shop_id,
                            "room_area": _this.cqjh_list_form.room_area || '',
                            "goods_type": _this.cqjh_list_form.goods_type,
                            "goods_name": _this.cqjh_list_form.goods_name,
                            "mobile": _this.cqjh_list_form.mobile
                        }
                    },
                    "comment": ""
                };
                if(_this.cqjh_sortby == 'take_deposit_store') {
                    url = "FinanceReport/getTakeDepositSumListByStore";
                    data.request.param.store_id = _this.cqjh_list_form.store_id;
                }
                Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.cqjh_list_total = Number(res.data.response.result.count);
							_this.cqjh_total_in_quantity = res.data.response.result.total_in_quantity;
							_this.cqjh_total_out_quantity = res.data.response.result.total_out_quantity;
							_this.cqjh_in_price_total = res.data.response.result.in_price_total;
							_this.cqjh_out_price_total = res.data.response.result.out_price_total;
						}
						_this.cqjh_list = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
                });
			},
			// 查询
			cqjhQuery() {
				this.getCqjhList(1);
            },
            // 统计方式
            cqjhSortBy: function(type) {
                const _this = this;

                _this.cqjh_sortby = type;
                $('.cqjh-type').removeClass('el-button--primary');
                if(type == 'take_deposit_goods') {
                    $('.cqjh-type').eq(0).addClass('el-button--primary');
                } else if(type == 'take_deposit_store') {
                    $('.cqjh-type').eq(1).addClass('el-button--primary');
                    _this.cqjh_list_form.store_id = '';
                    _this.getStore(_this.cqjh_list_form.shop_id)
                }
                _this.getCqjhList(1);
            },
            // 导出
            cqjhExportAll(val) {
                if(this.cqjh_sortby == 'take_deposit_goods') {
                    this.cqjh_export_ids = val ? this.cqjh_export_list1 : [];
                } else if(this.cqjh_sortby == 'take_deposit_store') {
                    this.cqjh_export_ids = val ? this.cqjh_export_list2 : [];
                }
                this.cqjh_export_sign = false;
			},
			cqjhExportChange(val) {
                const len = val.length;
                if(this.cqjh_sortby == 'take_deposit_goods') {
                    this.cqjh_export_all = len === this.cqjh_export_list1.length;
                    this.cqjh_export_sign = len > 0 && len < this.cqjh_export_list1.length;
                } else if(this.cqjh_sortby == 'take_deposit_store') {
                    this.cqjh_export_all = len === this.cqjh_export_list2.length;
                    this.cqjh_export_sign = len > 0 && len < this.cqjh_export_list2.length;
                }
			},
            cqjhExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/takeDepositSumExport?bill_type=" + _this.cqjh_sortby
                        }
                    },
                    "comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.cqjh_export_ids = res.data.response.result.export_fields;
                            _this.cqjh_export_type = res.data.response.result.export_type;
                            _this.cqjhExportChange(_this.cqjh_export_ids);
                        } else {
                            if(_this.cqjh_sortby == 'take_deposit_goods') {
                                _this.cqjh_export_ids = _this.cqjh_export_list1;
                            } else if(_this.cqjh_sortby == 'take_deposit_store') {
                                _this.cqjh_export_ids = _this.cqjh_export_list2;
                            }
                            _this.cqjh_export_type = '1';
                            _this.cqjhExportChange(_this.cqjh_export_ids);
                        }
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.cqjh_list_export)
                }, function() {
                    _this.checkExport();
                });
            },

            // 检查导出状态
            checkExport() {
                let _this = this
                var data = {
                    "header": Vue.request_header,
                    "request": {
                        "type": _this.cqjh_sortby == 'take_deposit_goods' ? 'depositSumByGoods' : 'depositSumByStore',
                        "param": {
                            "page": _this.cqjh_list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.cqjh_list_form.start_date,
                            "end_date": _this.cqjh_list_form.end_date,
                            "shop_id": _this.cqjh_list_form.shop_id,
                            "room_area": _this.cqjh_list_form.room_area || '',
                            "goods_type": _this.cqjh_list_form.goods_type,
                            "goods_name": _this.cqjh_list_form.goods_name,
                            "mobile": _this.cqjh_list_form.mobile,
                        }
                    },
                    "comment": ""
                }
                if (_this.cqjh_sortby == 'take_deposit_store') {
                    data.request.param.store_id = _this.cqjh_list_form.store_id;
                }
                Vue.axios.post('exportBook/exportCheck', data)
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.cqjhExport();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 预约导出
            doBookExport() {
                let _this = this;
                let export_fields = JSON.stringify(this.cqjh_export_ids);
                var data = {
                    "header": Vue.request_header,
                    "request": {
                        "type": _this.cqjh_sortby == 'take_deposit_goods' ? 'depositSumByGoods' : 'depositSumByStore',
                        "param": {
                            "page": _this.cqjh_list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.cqjh_list_form.start_date,
                            "end_date": _this.cqjh_list_form.end_date,
                            "shop_id": _this.cqjh_list_form.shop_id,
                            "room_area": _this.cqjh_list_form.room_area || '',
                            "goods_type": _this.cqjh_list_form.goods_type,
                            "goods_name": _this.cqjh_list_form.goods_name,
                            "mobile": _this.cqjh_list_form.mobile,
                            "export_fields": export_fields,
                        }
                    },
                    "comment": ""
                }
                if (_this.cqjh_sortby == 'take_deposit_store') {
                    data.request.param.store_id = _this.cqjh_list_form.store_id;
                }
                Vue.axios.post('exportBook/addExportBook', data)
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.book_export_log_list = res.data.response.result.log_list
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },

            // 导出
            cqjhExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport/takeDepositSumExport?bill_type=" + this.cqjh_sortby +
                    "&start_date=" + this.cqjh_list_form.start_date +
                    "&end_date=" + this.cqjh_list_form.end_date +
                    "&shop_id=" + this.cqjh_list_form.shop_id +
                    "&room_area=" + (this.cqjh_list_form.room_area || '') +
                    "&goods_type=" + this.cqjh_list_form.goods_type +
                    "&goods_name=" + this.cqjh_list_form.goods_name +
                    "&mobile=" + this.cqjh_list_form.mobile +
                    "&store_id=" + (this.cqjh_list_form.store_id || '') +
                    "&export_fields=" + JSON.stringify(this.cqjh_export_ids) +
                    "&export_type=" + this.cqjh_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>